import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import transaction from './modules/serviceTransaction'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    webpushAuth: null,
    minWidth: false,
    drawer: true,
    showBusiness: false,
    business: {}
  },
  getters: {
    webpushAuth: state => state.webpushAuth,
    drawer: state => state.drawer,
    business: state => state.business,
    showBusiness: state => state.showBusiness
  },
  mutations: {
    setWebpushAuth(state, payload) {
      state.webpushAuth = payload
    },
    setDrawer(state, payload) {
      state.drawer = payload
    },
    setMinWidth(state, payload) {
      state.minWidth = payload
    },
    changeDrawer(state) {
      state.drawer = !state.drawer
    },
    setBusiness(state, payload) {
      state.business = payload
    },
    setShowBusiness(state, payload) {
      state.showBusiness = payload
    },
  },
  actions: {
  },
  modules: {
    user,
    transaction
  }
})
